import { FC } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    minWidth: 'min(480px, 90vw)',
    maxWidth: 'min(560px, 95vw)',
    borderRadius: 12
  },
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(2, 2.5, 1.5)
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2.5)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1.5, 2.5),
    justifyContent: 'space-between'
  },
  '& .MuiButton-root': {
    minHeight: '40px',
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600
  }
}));

interface ViewWeightNoteModalProps {
  open: boolean;
  onClose: () => void;
  onView: () => void;
  onDownload: () => void;
  selectedWeightNoteId: number;
}

const ViewWeightNoteModal: FC<ViewWeightNoteModalProps> = (props) => {
  return (
    <StyledDialog open={props.open} onClose={props.onClose}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              flexShrink: 0
            }}
          >
            <DescriptionIcon />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ fontSize: '1.15rem', fontWeight: 700, lineHeight: 1.2 }}>
              Vigtarnóta
            </Box>
            <Box sx={{ fontSize: '0.85rem', color: 'text.secondary' }}>
              nr: {props.selectedWeightNoteId}
            </Box>
          </Box>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText sx={{ color: 'text.primary' }}>
          Viltu skoða vigtarnótuna í nýjum flipa eða sækja hana sem PDF skjal?
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          onClick={props.onClose}
          variant="text"
          color="inherit"
          startIcon={<CloseIcon />}
        >
          Hætta við
        </Button>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            onClick={props.onView}
            variant="outlined"
            color="primary"
            startIcon={<VisibilityIcon />}
          >
            Skoða
          </Button>
          <Button
            onClick={props.onDownload}
            variant="contained"
            color="primary"
            disableElevation
            startIcon={<DownloadIcon />}
          >
            Sækja
          </Button>
        </Box>
      </DialogActions>
    </StyledDialog>
  );
};

export default ViewWeightNoteModal;
